// Custom formatters for vue-i18n
import getConfig from '@/utils.js'
import { format, parseISO } from 'date-fns'
import de from '@/locales/de.json'

const currency = getConfig().currency
const locale = getConfig().locale

// Custom number and date formatters for vue-i18n
export const numberFormats = {
  de: {
    currency: {
      style: 'currency',
      currency: currency
    },
    decimal: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    },
    percent: {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    },
    // For values stored in cents
    eurocent: {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'symbol'
    }
  },
  'de-CH': {
    currency: {
      style: 'currency',
      currency: 'CHF'
    },
    decimal: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    },
    percent: {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    },
    eurocent: {
      style: 'currency',
      currency: 'CHF',
      currencyDisplay: 'symbol'
    }
  }
}

// Custom formatter function for special cases
export function customFormatter(value, formatType) {
  if (formatType === 'EURO') {
    return Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    }).format(value)
  }

  if (formatType === 'EUROCENT') {
    return Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    }).format(value / 100)
  }

  if (formatType && formatType.match('^date')) {
    if (!(value instanceof Date)) {
      if (value === 'infinity') {
        return '∞'
      } else if (!value) {
        return ''
      }
      value = parseISO(value)
    }
    let dateFormat = de.date[formatType] || 'X'
    return format(value, dateFormat)
  }

  if (formatType === 'BOOL') {
    return value ? '✓' : '❌'
  }

  if (formatType === 'NUMBER') {
    return Intl.NumberFormat(locale, {
      style: 'decimal'
    }).format(value)
  }

  return value
}

// Export helper function to use in components
export function useCustomFormat() {
  return {
    format: customFormatter
  }
}
